module.exports = __webpack_public_path__ + "img/notary-journal_B09KDL4VKK.b9a2c9ee.jpg";